 jQuery(document).ready(function() {

   /*   jQuery("#after-slider-products").owlCarousel({
       loop: true,
        nav: false,
        dots: true,
        margin:0,
        autoplay: false,
   autoplayTimeout: 5000,
        animateOut: 'fadeOut',
       responsive: {
        0:{
          items: 1
        },
        769:{
          items: 2
        },
        1024:{
          items: 4
        }
    }
      });
*/
setTimeout(()=>{

    jQuery("#your-copper-to-fiber-connection-slider").owlCarousel({
       loop: true,
        nav: false,
        dots: false,
        margin:15,
        autoplay: true,
        autoplayTimeout: 5000,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            }
        }
      });
  
jQuery('#after-slider-products').owlCarousel({
     loop: true,
        nav: false,
        dots: true,
        margin:0,
        autoplay: true,
        autoplayTimeout: 5000,
   responsive: {
        0:{
          items: 1
        },
        480:{
          items: 1
        },
     600:{
          items: 2
        },
        769:{
          items: 3
        },
     1024:{
          items: 4
        }
    }
 });
}, 1000);

  jQuery("#testimonials-slider").owlCarousel({
       loop: true,
        nav: true,
        dots: false,
        margin:15,
        autoplay: true,
        autoplayTimeout: 5000,
    navText : ["<i class='fa-solid fa-arrow-left-long'></i>","<i class='fa-solid fa-arrow-right-long'></i>"],
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            },
            1000: {
                items: 1
            }
        }
      });
  jQuery("#best-seller-products-slider").owlCarousel({
       loop: true,
        nav: true,
        dots: false,
        margin:15,
        autoplay: true,
        autoplayTimeout: 5000,
    navText : ["<i class='fa-solid fa-chevron-left'></i>","<i class='fa-solid fa-chevron-right'></i>"],
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
           768: {
                items: 3
            },
            1000: {
                items: 4
            }
        }
      });
  jQuery("#related-products-slider").owlCarousel({
       loop: true,
        nav: true,
        dots: false,
        margin:15,
        autoplay: true,
        autoplayTimeout: 5000,
    navText : ["<i class='fa-solid fa-chevron-left'></i>","<i class='fa-solid fa-chevron-right'></i>"],
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
           768: {
                items: 3
            },
            1000: {
                items: 4
            }
        }
      });

      
    });




/* Tabs for product details page */
jQuery("#nav-description").removeClass("tab-pane fade").addClass("tab-pane show active");
/* sidebar
 jQuery(document).ready(function(){
    jQuery('ul > li.menu-item svg').click(function(){
      jQuery('ul.sub-menu').removeClass('active');
    jQuery(this).siblings('ul.sub-menu').toggleClass('active');     
  });
  });
 */
 document.addEventListener("DOMContentLoaded", function () {
  var acc = document.querySelectorAll(".accordion");
  acc.forEach(function (accordion) {
    accordion.addEventListener("click", function () {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      var icon = this.querySelector(".icon");
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
        icon.textContent = "+"; 
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
        icon.textContent = "−"; 
      }
    });
  });
});

jQuery(document).ready(function(){
    jQuery('ul > li.menu-item svg').click(function(){
      var subMenu = jQuery(this).siblings('ul.sub-menu');
      jQuery('ul.sub-menu.active').not(subMenu).removeClass('active');
    subMenu.toggleClass('active');     
  });
  });
 var all = [];

jQuery('#FacetFiltersForm details').each(function(i, obj) {
    var currentElement = jQuery(this);
    var element = $(obj).find('div fieldset ul.no-js-hidden li');
    var filterOptionCount = element['length']

  all.push(filterOptionCount); 
    if (filterOptionCount < 2) {
      jQuery(this).hide();
    
    }else{
      jQuery(this).show();
    }
});

var min = Math.max.apply(Math, all);

if(min<= 1){
  jQuery('form#FacetFiltersForm').hide();
}

/* sidebar menu */
  jQuery(function($) {
     var path = window.location.href; 
     jQuery('.sub-categories .sidebar-menu ul li a').each(function() {
      if (this.href === path) {
       jQuery(this).addClass('active');
       jQuery(this).closest('li').find('>ul.sub-menu').addClass('active');
      }
     });
    });

 jQuery(document).ready(function(){
   jQuery(".sub-categories .sidebar-menu ul li a.active").parents('.sub-categories .sidebar-menu ul').addClass('active');
   setTimeout(function() {
     jQuery(".sub-categories .sidebar-menu ul li a.active").parents('.sub-categories .sidebar-menu ul').addClass('active');
   }, 5000);
});


 function instantBuy(){
     var $ = jQuery;

   var formParams = $('form.cart').serialize();
     $.ajax({
      url: "/cart/add",
      type: "post",
      data: formParams,
      success: function(){ 
       window.location.href = "/checkout";
      },
      error: function(){
      }
     })
 }


